// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--fe094";
export var footerBottom = "footer-module--footer-bottom--9f1bb";
export var footerContact = "footer-module--footer-contact--1234d";
export var footerContent = "footer-module--footer-content--4b7fb";
export var footerInfo = "footer-module--footer-info--466ef";
export var footerLinks = "footer-module--footer-links--c234e";
export var footerNewsletter = "footer-module--footer-newsletter--fc84f";
export var footerSocial = "footer-module--footer-social--e0fdb";
export var goToHead = "footer-module--go-to-head--5aa9e";